// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9d0c5e3d","389":"37dda583","453":"e05597e9","455":"ec60765c","977":"bb7802e4"}[chunkId] + ".chunk.js";
};